import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getHistory = async () => {
  loaderService.show();
  try {
    const response = await apiService.get('insights/admin/entradas/sistema/historico/?tipo=pendientes');
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getHistoryDetails = async (entryId) => {
  loaderService.show();
  try {
    const response = await apiService.get(
      `insights/admin/entradas/sistema/historico/?tipo=entrada&id_entrada=${entryId}`,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const acceptAndReject = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.put(
      'insights/admin/entradas/sistema/historico/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export { getHistory, getHistoryDetails, acceptAndReject };
